var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "text-translation"
  }, [_c("section", {
    style: {
      background: `url(${_vm.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.imageUrl,
      title: _vm.bannerTitle,
      description: _vm.bannerText
    }
  })], 1), _c("section", {
    staticClass: "products"
  }, [_c("div", {
    staticClass: "products-main"
  }, [_c("Title", {
    attrs: {
      title: "产品介绍"
    }
  }), _c("Translate")], 1)]), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "advantages-main"
  }, [_c("Title", {
    attrs: {
      title: "产品优势"
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("Advantages2", {
    attrs: {
      leftItems: _vm.adsListLeft,
      rightItems: _vm.adsListRight
    }
  })], 1)], 1)]), _c("section", {
    staticClass: "application"
  }, [_c("div", {
    staticClass: "application-main"
  }, [_c("Title", {
    attrs: {
      title: "应用场景"
    }
  }), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.funcList, function (item, index) {
    return _c("BusiCard", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.desc,
        img: item.img,
        dark: true
      }
    });
  }), 1)], 1)]), _c("SpeechCase", {
    attrs: {
      title: "客户案例",
      casesList: _vm.casesList,
      customWidth: 302
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };